// Copyright (c) Docugami, Inc. All rights reserved.

import { PublicClientApplication, Configuration, InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { PowerAutomateWorkflow } from 'components/power_automate/PowerAutomateWorkflow';
import { Config } from "config";
import { Redirect } from "react-router";

const DocugamiAppConfig: Configuration = {
    auth: {
        clientId: Config.powerAutomate.auth.clientId,
        authority: Config.powerAutomate.auth.authority
    }
}

const pca = new PublicClientApplication(DocugamiAppConfig)

export const PowerAutomateWorkflowPage = (): JSX.Element => {
    return (
        <MsalProvider instance={pca}>
            <MsalAuthenticationTemplate
                interactionType={InteractionType.Popup}
                errorComponent={Error}
                authenticationRequest={{ scopes: Config.powerAutomate.auth.scopes }}>
                    <PowerAutomateWorkflow />
            </MsalAuthenticationTemplate>
        </MsalProvider>
    )
}

const Error = (): JSX.Element => {
    return <Redirect to="/" />
}
